import React from "react";
import styles from "./ProductAttributesGrid.module.css";

interface Attribute {
  name: string;
  values: { name: string; colorHex?: string | null }[];
}

interface Props {
  attributes: Attribute[];
}

const ProductAttributesGrid: React.FC<Props> = ({ attributes }) => {
  if (!attributes || attributes.length === 0) return null;

  return (
    <section
      className={styles.gridSection}
      aria-label="Características del producto"
    >
      <h3 className={styles.title}>Características</h3>
      <div className={styles.grid}>
        {attributes.map((attr) =>
          attr.values.map((val, idx) => (
            <div key={attr.name + idx} className={styles.chip}>
              <span className={styles.attrName}>{attr.name}:</span>
              <span className={styles.attrValue}>
                {val.colorHex && (
                  <span
                    className={styles.colorDot}
                    style={{ background: val.colorHex }}
                    title={val.name}
                  />
                )}
                {val.name}
              </span>
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default ProductAttributesGrid;
